<template>
    <div class="login-suss">
        <div v-if="showLogin" class="from-box">
            
            <el-form
              size="mini"
              label-width="40px"
            >

                <el-form-item label="账号">
                    <div class="input-box">
                        <el-input
                            size="mini"
                            type="text"
                            placeholder="请输入绑定账号"
                            v-model="loginData.seller_name"
                            autofocus
                        />
                    </div>
                </el-form-item>
                <el-form-item label="密码">
                    <div class="input-box">
                        <el-input
                            size="mini"
                            type="password"
                            placeholder="请输入密码"
                            v-model="loginData.password"
                            name="password"
                        />
                    </div>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="login" size="mini">确认绑定</el-button>
                </el-form-item>
            </el-form>
            
            
        </div>
        <div v-else class="tips">
            {{ wxText }}
        </div>
    </div>
    </template>
    
    <script>
import router from '../../router';
    export default {
        data(){
            return{
                wxText:"登录成功",
                showLogin:false,
                code:"",
                loginData:{
                    seller_name:"",
                    password:""
                },
                wxData:{

                }
            }
        },
        methods:{
            async login(){
                this.loginData.isBind = 1
                let res = await this.$api.login(this.loginData);
                if (res.loginErr) {
                    console.log("res",res);

                    if(res.msg.includes('禁用')){
                        return this.$erMsg("账号已禁用")
                    }
                }else{
                    if (res.joinin_state == 31) {
                        res = false;
                        return this.$erMsg("该企业审核失败");
                    } else if (res.joinin_state == 404) {
                        res = false;
                        return this.$erMsg("该企业未认证");
                    } else {
                        if (res.sc_name == "A-供货商") {
                            this.$warMsg("该账号禁止登录");
                            return 
                        }
                        this.$store.commit("UpDateState", res);
                        console.log("this.wxData",this.wxData);
                        
                        let bindRes = await this.$api.editAccInfo({
                            account_id:this.$store.state.member_id.split("-")[1],
                            ...this.wxData
                        })
                        
                        if(bindRes){
                            this.$suMsg("绑定成功")
                            this.wxText = "绑定成功"
                            try {
                                window.parent.postMessage({ res}, '*'); // '*'表示接受任何源的消息，生产环境中建议指定明确的目标源
                            } catch (error) {
                                parent.postMessage({ res}, '*');
                                console.log("error",error);
                            }
                        }else{
                            this.$erMsg("绑定失败"+bindRes.msg)
                        }
                        // if(res.shop &&res.shop==1780){
                            
                            
                            
                        // }else{
                        //     this.$warMsg("该账号非华诺威用户");
                        // }
                    }
                }
            }
        },
        async created(){
            console.log("url是",location.href);
            let url = location.href
            // // 创建一个URL对象
            let parsedUrl = new URL(url);

            // 请注意，如果您的URL中的查询参数是在hash部分之后，
            // 那么需要手动处理hash部分来获取查询参数。
            // 先获取hash部分
            let hash = parsedUrl.hash;

            // 如果hash部分存在，则从hash部分提取查询参数
            if (hash.includes('?')) {
                // 获取hash中的查询字符串部分
                let queryString = hash.substring(hash.indexOf('?') + 1);
                console.log("queryString",queryString);
                
                // 使用URLSearchParams处理查询字符串
                let searchParams = new URLSearchParams(queryString);
                
                // 获取code参数的值
                let code = searchParams.get('code');
                this.code = code 
                let bindState = searchParams.get('state');
                
                console.log("获得的参数",code); // 输出: 041OBN100mcT3U1DYK200aRczc0OBN12
                console.log("获取到的",bindState);
                
                if(bindState=='bind'){
                    
                    let member_id = this.$route.params.id || ""
                    let res = await this.$api.wxLogin({
                        code,
                        member_id:member_id?member_id:this.$store.state.member_id
                    })
                    
                    if(res&&res.code==1){
                        this.$erMsg("绑定失败")
                        this.wxText = res.msg
                    }else{
                        this.$suMsg("绑定成功")
                        this.wxText = "绑定成功"
                        try {
                            window.top.location.href = window.top.location.href.split("#")[0]+`#/`
                            window.top.location.reload(true)
                        } catch (error) {
                            parent.postMessage({res:"reload1" }, '*');    
                        }
                    }
                    
                    // 在iframe内部执行
                    // window.top.location.href = 
                }else{
                    let res = await this.$api.wxLogin({
                        code,
                        type:"login"
                    })
                    console.log("res",res);
                    if(res.code==1){
                        console.log("未绑定微信");
                        this.wxText = "请先登录平台账号进行绑定"
                        setTimeout(()=>{
                            this.showLogin = true
                            this.wxData = {
                                wx_id:res.data.unionid,
                                wx_img:res.data.headimgurl,
                                wx_nickName:res.data.nickname
                            }
                        },1500)
                        
                        // let wxRes = await this.$https(`https://api.weixin.qq.com/sns/userinfo?access_token=${res.data.access_token}&openid=${res.data.openid}`)
                       

                        // res.data.unionid
                    }else{
                        // 在iframe内部执行
                        try {
                            window.parent.postMessage({ res}, '*'); // '*'表示接受任何源的消息，生产环境中建议指定明确的目标源
                        } catch (error) {
                            parent.postMessage({ res}, '*');
                            console.log("error",error);
                        }
                        
                    }
                    
                }
            } else {
                console.log("No query parameters found in the hash.");
            }
            
        },
        props:{
            
        }
    }
    </script>
    
    <style lang="scss">
    .login-suss{
        .tips{
            width: 300px;
            line-height: 200px;
            font-weight: 700;
            font-size: 24px;
            text-align: center;
        }
        .from-box{
            padding: 12px;
            width: 300px;
            text-align: center;
        }
        .el-form{
            // width: 280px;
            // width: 8.484848rem /* 280/33 */;
            width: 220px;
            .el-form-item{
                margin-bottom: 5px;
            }
        }
    }
    </style>